import Phaser from 'phaser';
import { COLORS } from '../colors';
import { LEGEND } from '../grid';

/**
 * Molecule legend, rendered in its OWN rounded panel above the organ pool
 * sidebar (separated for visual clarity, and to free up pool real-estate for
 * up to six organs in the capstone levels):
 *   blue O    = oxygen
 *   green hex = nutrients
 *   yellow ★  = carbon dioxide
 */
export function drawLegend(scene: Phaser.Scene): void {
  const w = LEGEND.width - 16;
  const h = LEGEND.height - 10;
  const x = LEGEND.x + 8;
  const y = LEGEND.y + 5;

  const g = scene.add.graphics();
  g.fillStyle(0x000000, 0.3);
  g.fillRoundedRect(x + 3, y + 4, w, h, 8);
  g.fillStyle(COLORS.legendBg, 1);
  g.fillRoundedRect(x, y, w, h, 8);
  g.lineStyle(2, 0x222222, 0.4);
  g.strokeRoundedRect(x, y, w, h, 8);
  g.setDepth(5);

  const rowH = 28;
  const padX = 14;
  const startY = y + 18;

  const rows: { tex: string; label: string }[] = [
    { tex: 'mol-oxygen', label: '= oxygen' },
    { tex: 'mol-food', label: '= nutrients' },
    { tex: 'mol-co2', label: '= carbon dioxide' },
  ];

  rows.forEach((row, i) => {
    const cy = startY + i * rowH;
    const sprite = scene.add.image(x + padX + 12, cy, row.tex);
    sprite.setDepth(6);
    scene.add
      .text(x + padX + 32, cy, row.label, {
        fontFamily: 'Arial, sans-serif',
        fontSize: '16px',
        color: '#222222',
      })
      .setOrigin(0, 0.5)
      .setDepth(6);
  });
}
